<script>
import { mapActions } from 'vuex'
import { getKey } from '@/assets/utils'
/**
 * @description 重审卡中间页面，根据判断条件跳转不同页面
 * 1、未购买和已失效，跳转特权卡详情（需要带token）
 * 2、已购买，跳转对应（授信或提现）拒绝页面
 */

export default {
  data () {
    return {
      isHome: this.$route.query.isHome, // 是否是首页卡片跳转来的，值为T
      from: this.$route.query.from, // 来源页面
      isBack: this.$route.query.back, // 是否从特权卡进来
      isCat: this.$route.query.isCat, //  是否是三个猫点进来的
      status: '',
      applyNo: '',
      userInfo: null,
      limitInfo: null
    }
  },
  async created () {
    if (this.isBack === 'T') {
      this.handleExit()
      if (this.from) {
        return (window.location.href = this.from)
      }
    }
    // this.getRoute()
    await Promise.all([
      this.queryUserInfo(),
      this.queryLimit()
    ]).catch(() => {
      this.$bus.$emit('error')
    })
    this.handleJump()
  },
  methods: {
    ...mapActions('user', [
      'getUserInfoX',
      'getLimitX',
      'fundPageRoute'
    ]),
    async getRoute () {
      const { success, data } = await this.fundPageRoute()
      if (success && data) {
        const { fundPageType, memberGoodsCd } = data
        if (fundPageType === 'MEMBER' && memberGoodsCd === 'XAC_M') {
          return this.$router.push(`/vip/index?findTarget=${memberGoodsCd}`)
        }
      }
    },
    // 获取用户信息
    async queryUserInfo () {
      const userInfo = await this.getUserInfoX({
        forceUpdate: true
      })
      this.userInfo = userInfo
    },
    // 查询用户状态
    async queryLimit () {
      const { success, data } = await this.getLimitX({
        loanPlatform: 'TMD'
      })
      if (success) {
        this.limitInfo = data
        // 授信拒绝
        if (data.creditStatus === 'CREDIT_REFUSED') {
          this.status = 'credit'
          this.applyNo = data.serialNo
        }
        // 提现拒绝
        if (data.creditStatus === 'LOAN_REFUSED') {
          this.status = 'loan'
          this.applyNo = data.lastLoanSerialNo
        }
      }
    },
    // 跳转逻辑
    handleJump () {
      if (this.userInfo && this.limitInfo) {
        if (this.status === 'credit') {
          // 只有导流用户才走重审卡的逻辑
          if (this.userInfo.hasDiversion) {
            this.jumpCreditRetrial()
            // 授信重审卡
            // const { raCard } = this.userInfo.privilegeCardDetail || {}
            // if (raCard) {
            //   if (['USE_OVER', 'OVERDUE'].includes(raCard.status) || this.$route.query.toCard) {
            //     // 已失效
            //     this.jumpCreditRetrial()
            //   } else {
            //     // 在购买有效期内
            //     this.jumpCreditResult()
            //   }
            // } else {
            //   // 未购买
            //   this.jumpCreditRetrial()
            // }
          } else {
            this.jumpCreditResult()
          }
        } else if (this.status === 'loan') {
          // 只有导流用户才走重审卡的逻辑
          if (this.userInfo.hasDiversion) {
            // 提现重审卡
            // const { rwCard } = this.userInfo.privilegeCardDetail || {}
            // if (rwCard) {
            //   if (['USE_OVER', 'OVERDUE'].includes(rwCard.status) || this.$route.query.toCard) {
            //     // 已失效
            //     this.jumpLoanRetrial()
            //   } else {
            //     // 在购买有效期内
            //     this.jumpWithdrawResult()
            //   }
            // } else {
            //   // 未购买
            //   this.jumpLoanRetrial()
            // }
            this.jumpLoanRetrial()
          } else {
            this.jumpWithdrawResult()
          }
        }
      }
    },
    // 跳转授信重审卡页面
    jumpCreditRetrial () {
      if (this.isHome === 'T') {
        return this.jumpCreditResult()
      }
      const channel = getKey('channel') || ''
      const url = `${process.env.VUE_APP_PAYURL}/privilege/credit/retrial?token=${this.userInfo.token}${this.from ? `&from=${this.from}` : ''}&channel=${channel}&refurl=${window.location.origin}`
      window.location.replace(url)
    },
    // 跳转提现重审卡页面
    jumpLoanRetrial () {
      if (this.isHome === 'T') {
        return this.jumpWithdrawResult()
      }
      const channel = getKey('channel') || ''
      const url = `${process.env.VUE_APP_PAYURL}/privilege/withdraw/retrial?token=${this.userInfo.token}${this.from ? `&from=${this.from}` : ''}&channel=${channel}&refurl=${window.location.origin}`
      window.location.replace(url)
    },
    jumpCreditResult () {
      this.$router.replace(`/authentication/result?applyNo=${this.applyNo}`)
    },
    jumpWithdrawResult () {
      this.$router.replace(`/withdraw/result?loanApplyNo=${this.applyNo}`)
    }
  },
  render () {
    return <div></div>
  }
}
</script>